export default __webpack_public_path__ + "static/media/facility_05_3.78a3eaeb.jpg";